import { CREATE_ACCOUNT_COUNTRY_CODE } from "utils/constants";
import { getStytchTemplateCountry } from "utils/getStytchTemplateCountry";

export const useCreateAccountTemplate = () => {
  let index: string = getStytchTemplateCountry();
  const countryTemplate = CREATE_ACCOUNT_COUNTRY_CODE[index];
  return countryTemplate;
};
